import { Modal } from "react-bootstrap";

const DeleteConfirmationModal = ({ show, onHide, onConfirm, userName, walletBalance, loadingBalance, submitting }) => {
    const hasBalance = walletBalance && parseFloat(walletBalance) > 0;

    return (
        <Modal show={show} onHide={onHide} centered>
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">Delete User</h5>
                    <button
                        type="button"
                        onClick={onHide}
                        className="btn-close"
                        disabled={submitting}
                    />
                </div>
                <div className="modal-body">
                    {loadingBalance ? (
                        <div className="text-center py-3">
                            <div className="spinner-border spinner-border-sm text-primary" role="status">
                                <span className="visually-hidden">Loading…</span>
                            </div>
                        </div>
                    ) : (
                        <>
                            <p className="fs-16 mb-2">
                                Are you sure you want to delete <strong>{userName}</strong>?
                            </p>
                            {hasBalance && (
                                <div className="alert alert-warning mb-2">
                                    <strong>This user has a wallet balance of KES {walletBalance}.</strong>
                                    <br />
                                    Proceeding will automatically reverse the full balance to the partner vault and notify all super admins and accountants.
                                </div>
                            )}
                            <p className="text-danger font-w600 mb-0">This action cannot be undone.</p>
                        </>
                    )}
                </div>
                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={onHide}
                        disabled={submitting}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn btn-danger"
                        onClick={onConfirm}
                        disabled={loadingBalance || submitting}
                    >
                        {submitting ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                                Deleting…
                            </>
                        ) : 'Delete'}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default DeleteConfirmationModal;